import { Flex, Select, Form, Input, Button } from 'antd'
import { FC } from 'react'
import { relayStore } from '../store/relay'
import { useNavigate, useParams } from 'react-router-dom'
import { RNElectric, RNChecks } from '../helpers/routeNames'
import { PageBreadcrumb } from '../components/PageBreadcrumb'

export const Electric: FC = () => {
	const { relayTypes, createElectric } = relayStore()
	const [form] = Form.useForm()
	const { relayTypeId } = useParams()
	const navigate = useNavigate()

	const relayTypeName = relayTypes.find((rt) => rt.id === relayTypeId)?.name

	return (
		<Flex vertical>
			<PageBreadcrumb
				items={[
					{ label: 'Характеристики', path: RNChecks },
					{ label: relayTypeName || 'Тип реле' },
					{ label: 'Электрика' }
				]}
			/>
			<header>
				<h1 style={{ margin: 0 }}>Электрические работы</h1>
			</header>
			<main>
				<Form
					form={form}
					layout="vertical"
					variant="filled"
					initialValues={{
						relayTypeId
					}}
					onFinish={(values) => {
						createElectric(values)
						navigate(RNElectric)
					}}>
					<h3>Тип реле:</h3>
					<Form.Item
						label="Тип реле"
						name="relayTypeId"
						rules={[{ required: true }]}>
						<Select
							style={{ minWidth: 200 }}
							disabled
							options={relayTypes.map((type) => ({
								value: type.id,
								label: type.name
							}))}
						/>
					</Form.Item>

					<Form.Item
						label="Название"
						name="name"
						rules={[
							{
								required: true,
								message:
									'Введите название механической характеристики'
							}
						]}>
						<Input />
					</Form.Item>

					<Form.Item
						label="Единица измерения"
						name="measurement"
						rules={[
							{
								required: true,
								message: 'Выберите единицу измерения'
							}
						]}>
						<Select>
							<Select.Option value="мм">
								мм
							</Select.Option>
							<Select.Option value="Н">
								Нютон
							</Select.Option>
							<Select.Option value="с">
								секунда
							</Select.Option>
							<Select.Option value="мА">
								милиампер
							</Select.Option>
							<Select.Option value="Ом">
								Ом
							</Select.Option>
							<Select.Option value="МОм">
								МОм
							</Select.Option>
							<Select.Option value="В(мА)">
								В(мА)
							</Select.Option>
						</Select>
					</Form.Item>

					<Form.Item
						label="Уровень"
						name="level"
						rules={[
							{
								required: true,
								message: 'Введите уровень'
							}
						]}>
						<Input type="number" />
					</Form.Item>

					<Form.Item
						label="Порядок"
						name="order"
						rules={[
							{
								required: true,
								message: 'Введите порядок'
							}
						]}>
						<Input type="number" />
					</Form.Item>

					<Form.Item
						label="Порядок в уровне"
						name="orderInLevel"
						rules={[
							{
								required: true,
								message: 'Введите порядок'
							}
						]}>
						<Input type="number" />
					</Form.Item>

					<Form.Item
						label="Диапазон колонок"
						name="colspan"
						rules={[
							{
								required: true,
								message: 'Введите диапазон колонок'
							}
						]}>
						<Input type="number" />
					</Form.Item>

					<Form.Item
						label="Диапазон строк"
						name="rowspan"
						rules={[
							{
								required: true,
								message: 'Введите диапазон строк'
							}
						]}>
						<Input type="number" />
					</Form.Item>

					<Form.Item
						label="Принимает ли значение"
						name="isAcceptsValue">
						<Select>
							<Select.Option value={true}>
								Да
							</Select.Option>
							<Select.Option value={false}>
								Нет
							</Select.Option>
						</Select>
					</Form.Item>

					<Form.Item
						label="Вертикальный ли электрическая хар."
						name="vertical">
						<Select>
							<Select.Option value={true}>
								Да
							</Select.Option>
							<Select.Option value={false}>
								Нет
							</Select.Option>
						</Select>
					</Form.Item>

					<Form.Item
						label="Родительская  электрическая хар."
						name="parentId">
						<Select>
							<Select.Option value={null}>
								Нет
							</Select.Option>
							{relayTypes
								.find((a) => a.id === relayTypeId)
								?.electrics.sort(
									(a, b) =>
										a.orderInLevel -
										b.orderInLevel
								)
								.map((type) => (
									<Select.Option
										key={type.id}
										value={type.id}>
										{type.parentId
											? relayTypes
													.find(
														(a) =>
															a.id ===
															relayTypeId
													)
													?.electrics.find(
														(m) =>
															m.id ===
															type.parentId
													)?.name + ' / '
											: ''}{' '}
										{type.name}
									</Select.Option>
								))}
						</Select>
					</Form.Item>

					<Form.Item>
						<Button type="primary" htmlType="submit">
							Сохранить
						</Button>
					</Form.Item>

					{/* <pre>{JSON.stringify(relayTypes, null, 2)}</pre> */}
				</Form>
			</main>
		</Flex>
	)
}
